import authAxios, { authHeader } from "../data";

const fetchAll = async (customerId: string) => {
  const response = await authAxios.get(
    "/api/CustomersBankAccounts?parentId=" + customerId,
    {
      headers: authHeader(),
    }
  );

  return response.data;
};

const save = async (request: any) => {
  const response = await authAxios.post("/api/CustomersBankAccounts", request, {
    headers: authHeader(),
  });

  return response.data;
};

const update = async (id: string, request: any) => {
  const response = await authAxios.put(
    `/api/CustomersBankAccounts/${id}`,
    request,
    {
      headers: authHeader(),
    }
  );

  return response.data;
};

const remove = async (id: string) => {
  const response = await authAxios.delete(`/api/CustomersBankAccounts/${id}`, {
    headers: authHeader(),
  });

  return response.data;
};

const CustomerBankAccountsService = {
  fetchAll,
  save,
  update,
  remove,
};

export default CustomerBankAccountsService;
